module.exports = __webpack_public_path__ + "static/media/guarantee.242e64eb.svg";